import {
  difference,
  differenceBy,
  flatMap,
  get,
  isEmpty,
  isNil,
  isNull,
  uniq,
} from 'lodash';
import moment from 'moment-timezone';
import hash from 'object-hash';
import { JudgementOnMeritsVictim } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { VICTIM, VICTIM_EXPERTISE_FIELDS } from 'containers/data-structure';
import { CIVIL_JUDGEMENT_TYPES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/constants';
import {
  CIVIL_JUDGEMENT_VICTIM_FIELDS,
  COMPTABLE_EXPERTISE_ID,
  JUDGEMENT_ON_MERITS_CIVIL_JUDGEMENT,
  MEDICAL_EXPERTISE_ID,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import {
  checkVictimExistanceCivilParty,
  formatExpertisesWithExpertReport,
  getVictimIds,
  hasOtherReason,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import {
  ICivilJudgement,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { MODE } from 'containers/CourtManagerLegalProceedings/ExpertReport/constants';
import {
  EXPERTISE_ACCOUNTING_ID,
  EXPERTISE_MEDICAL_ID,
} from 'containers/CourtManagerLegalProceedings/constants';
import {
  CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
  INCIDENT_TYPE,
} from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  isCivilJudgementVictimSubstantive,
  isNextOfKinsWithFormRejection,
  isNextOfKinsSubstantive,
  getSubstantiveWithoutCompensation,
} from 'containers/CourtManagerLegalProceedings/AppealOnMerits/utils';
import {
  getVictimAge,
  getVictimKey,
  getVictimRevenu,
  resolveExpertiseValue,
} from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import { Config } from 'containers/AppContainer/typings';
import { Victim } from 'containers/PreOpeningPage/typings';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import { VictimType } from 'typings/globalTypes';
import { GLOBAL_STATUS } from 'services/constants';
import { getTheLatestEvaluationObject } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';
export const formatMedExpertises = (
  civilJudgementOnMeritsFormMedicalExpertise: any,
) => {
  const medExpertises: any = [];
  civilJudgementOnMeritsFormMedicalExpertise.forEach((el: any) =>
    medExpertises.push(...el.medExpertises),
  );
  return medExpertises;
};

export const formatAccExpertises = (
  civilJudgementOnMeritsFormAccountingExpertise: any,
) => {
  const accExpertises: any = [];
  civilJudgementOnMeritsFormAccountingExpertise.forEach((el: any) =>
    accExpertises.push(...el.accExpertises),
  );
  return accExpertises;
};

export const formatMechanicalExpertises = (
  civilJudgementOnMeritsFormMechanicalExpertise: any,
) => {
  const mechanicalExpertises: any = [];
  civilJudgementOnMeritsFormMechanicalExpertise.forEach((el: any) =>
    mechanicalExpertises.push(...el.mechanicalExpertise),
  );
  return mechanicalExpertises;
};

export const getCivilJudgement = (judgementOnMerits: JudgementOnMeritsType) => {
  return get(
    judgementOnMerits,
    `${JUDGEMENT_ON_MERITS_CIVIL_JUDGEMENT}`,
    [],
  ).map((cj: ICivilJudgement) => {
    return {
      ...cj,
      civjmede: get(cj, 'civjmede', []).filter(civjmede => !civjmede.isOld),
      civjacce: get(cj, 'civjacce', []).filter(civjacce => !civjacce.isOld),
    };
  });
};
// finds the recent victimExpertise with same victimId and returns responsibilityShare
export const getResponsabilityShare = (
  civilJudgement: ICivilJudgement[],
  el: any,
  deceasedVictim: VictimType[],
  victimExpertises: any[],
  civilJudgementOnMeritsForm: any,
  responsibilityRate: string = '',
) => {
  let responsibilityShare: any = null;
  const cj = getCivilJudgementByVictimExpertise(civilJudgement, el);
  if (el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2') {
    const victim = deceasedVictim.find(dv => {
      return dv.victimId === el.victimId;
    });
    return get(victim, 'responsibilityShare');
  }
  const getExpertises = () =>
    victimExpertises.filter(v => v.victimId === el.victimId && !v.isOld);

  getExpertises().filter(res => {
    return cj.filter(
      // eslint-disable-next-line array-callback-return
      item => {
        // update civj
        const found =
          civilJudgementOnMeritsForm.find(
            (el: any) => el.id === item.id && !isNil(el.id),
          ) || {};

        if (res.expertiseId === 2 && !isEmpty(item.civjacce)) {
          return (responsibilityShare = get(
            found,
            'responsibilityShare',
            get(item, 'responsibilityShare'),
          ));
        }
        if (res.expertiseId === 1 && !isEmpty(item.civjmede)) {
          return (responsibilityShare = get(
            found,
            'responsibilityShare',
            get(item, 'responsibilityShare'),
          ));
        }
      },
    );
  });
  return !isNull(responsibilityShare)
    ? responsibilityShare
    : responsibilityRate;
};
export const getCivilJudgementByVictimExpertise = (
  civilJudgement: ICivilJudgement[],
  el: any,
) => {
  const cj = getCivilJudgementByVictimId(civilJudgement, el);
  return cj.filter((civj: any) => {
    if (!isEmpty(get(civj, 'civjmede', [])) && el.expertiseId === 1) {
      return civj;
    }

    if (!isEmpty(get(civj, 'civjacce', [])) && el.expertiseId === 2) {
      return civj;
    }
    // eslint-disable-next-line array-callback-return
    return;
  });
};
export const getCivilJudgementByVictimId = (
  civilJudgement: ICivilJudgement[] = [],
  el: any,
) => {
  return civilJudgement
    .map(civj => {
      return {
        ...civj,
        civjacce: get(civj, 'civjacce', []).filter(cjacce => {
          return cjacce.victimId === el.victimId;
        }),
        civjmede: get(civj, 'civjmede', []).filter(cjmede => {
          return cjmede.victimId === el.victimId;
        }),
        civjmece: [],
      };
    })
    .filter(cj => !isEmpty(cj.civjmede) || !isEmpty(cj.civjacce));
};

export const resolveValueFromForm = (valueFromForm: string, value: string) => {
  return !isEmpty(valueFromForm) ? valueFromForm : value;
};
export const resolveCalculationStartDate = (
  updatedCalculationStartDate: string,
  calculationStartDate: string,
) => {
  return updatedCalculationStartDate
    ? updatedCalculationStartDate
    : calculationStartDate;
};
export const getDeceasedVictim = (
  deceasedVictim: VictimType[],
  judgementAddClone: any,
  responsibilityShare: string,
) => {
  const deceasedVictimClone = get(judgementAddClone, 'deceasedVictim', []).map(
    (victim: VictimType) => ({
      victimId: victim.id,
      judiciaryAmount: victim.judiciaryAmount,
      responsibilityShare: responsibilityShare,
    }),
  );
  return hash(deceasedVictimClone) === hash(deceasedVictim)
    ? []
    : deceasedVictim.map((el: any) => ({
        ...el,
        responsibilityShare: responsibilityShare,
      }));
};
export const getDeceasedVictimAge = (
  victimId: string,
  victims: any,
  lossDate: string,
) => {
  const selectedVictim =
    victims.find((v: any) => Number(v.victimId) === Number(victimId)) || {};

  const dateOfBirth = get(selectedVictim, VICTIM.DATE_OF_BIRTH);

  return Number(
    moment(lossDate)
      .diff(dateOfBirth, 'years', true)
      .toFixed(2),
  );
};

export const checkVictimExistanceCivilPartyById = (
  id: number,
  victims: any,
) => {
  return (
    victims &&
    victims.map((element: { id: string }) => {
      return id && element.id?.toString() === id?.toString();
    })
  );
};

export const isJomAssociatedVictimsIncluded = (
  isMultiple: boolean | undefined,
  victimId: number,
  victimsEvaluationsToInclude: number[],
) => {
  if (isMultiple) return victimsEvaluationsToInclude.includes(victimId);
  return true;
};
export const resolveDeceasedVictimFees = (
  el: any,
  judgementOnMeritsVictims: JudgementOnMeritsVictim[],
) => {
  const jmv =
    judgementOnMeritsVictims.find(
      (item: JudgementOnMeritsVictim) => item.victimId === el.victimId,
    ) || {};

  return {
    medicalFees: get(jmv, 'medicalFees', null),
    funeralFees: get(jmv, 'funeralFees', null),
  };
};
export const addNewJudgementNonCompensation = (
  judgementNonCompensations: any,
  event: any,
  substrings: any,
  judgementOnMeritsId: number,
  civilJudgementVictimReason: any,
  item: any,
  incidentType: any,
) => {
  const incidentId =
    incidentType === INCIDENT_TYPE.VEHICLE ? 'vehicleId' : 'victimId';
  const civilJudgementIndex = judgementNonCompensations.findIndex(
    (item: any) => {
      return (
        get(item, incidentId) === Number(substrings[0]) &&
        item.expertiseJudgementAddDocumentId === Number(substrings[1])
      );
    },
  );
  if (civilJudgementIndex === -1) {
    judgementNonCompensations.push({
      expertiseJudgementAddDocumentId: Number(substrings[1]),
      [`${incidentId}`]: Number(substrings[0]),
      judgementOnMeritsId,
      [`${incidentType}`]: item,
      [event.target.name]: event.target.value,
    });
  } else {
    const civilJudgement =
      judgementNonCompensations.find(
        (el: any) =>
          get(el, incidentId) === Number(substrings[0]) &&
          el.expertiseJudgementAddDocumentId === Number(substrings[1]),
      ) || {};
    judgementNonCompensations[
      judgementNonCompensations.indexOf(civilJudgement)
    ] = {
      ...judgementNonCompensations[
        judgementNonCompensations.indexOf(civilJudgement)
      ],
      [event.target.name]: event.target.value,
      otherReason: !hasOtherReason(
        civilJudgementVictimReason,
        get(
          judgementNonCompensations[
            judgementNonCompensations.indexOf(civilJudgement)
          ],
          CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON,
          '',
        ),
      )
        ? null
        : event.target.name === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
        ? event.target.value
        : null,
    };
  }
};
export const addNewCivjJudgement = (
  id: number,
  civilJudgementData: any,
  expertiseId: any,
  civilJudgementOnMeritsFormAccountingExpertiseData: any,
  e: any,
  expertiseType: string,
  incidentType: string,
  incidentElement?: any,
) => {
  const incidentId =
    incidentType === INCIDENT_TYPE.VEHICLE ? 'vehiculeId' : 'victimId';
  const civilJudgement =
    civilJudgementOnMeritsFormAccountingExpertiseData.find(
      (item: any) => item.id === id,
    ) || {};

  const expertise =
    expertiseType === CIVIL_JUDGEMENT_TYPES.ACCOUNTING
      ? 'accExpertises'
      : expertiseType === CIVIL_JUDGEMENT_TYPES.MEDICAL
      ? 'medExpertises'
      : 'mechanicalExpertise';
  const substrings = expertiseId.split('-');
  const expertiseJudgementAddDocumentIdName = (expertiseType ===
  CIVIL_JUDGEMENT_TYPES.MECHANICAL
    ? 'expertiseJudgmentAddDocumentId'
    : 'expertiseJudgementAddDocumentId') as any;
  const currentCivilState =
    civilJudgementData.find((item: any) => item.id === civilJudgement.id) || {};

  const civj =
    expertiseType === CIVIL_JUDGEMENT_TYPES.ACCOUNTING
      ? 'civjacce'
      : expertiseType === CIVIL_JUDGEMENT_TYPES.MEDICAL
      ? 'civjmede'
      : 'civjmece';

  const civilJudgementIndex = civilJudgement[`${expertise}`].findIndex(
    (item: any) => {
      return (
        item[`${incidentId}`] === Number(substrings[0]) &&
        item[`${expertiseJudgementAddDocumentIdName}`] === Number(substrings[1])
      );
    },
  );
  const civilState = currentCivilState[`${civj}`].find((item: any) => {
    return (
      item[`${incidentId}`] === Number(substrings[0]) &&
      item[`${expertiseJudgementAddDocumentIdName}`] === Number(substrings[1])
    );
  });

  const civilStateIndex = currentCivilState[`${civj}`].indexOf(civilState);

  if (civilStateIndex !== -1) {
    currentCivilState[`${civj}`][civilStateIndex] = {
      ...currentCivilState[`${civj}`][civilStateIndex],
      [incidentId]: Number(substrings[0]),
      [`${incidentType}`]: incidentElement,
      [`${expertiseJudgementAddDocumentIdName}`]: Number(substrings[1]),
      calculatedCompensationAmount: 0,
      [e?.target.name]: e?.target.value,
    };
  } else {
    currentCivilState[`${civj}`] = [
      ...currentCivilState[`${civj}`],
      {
        [incidentId]: Number(substrings[0]),
        [`${incidentType}`]: incidentElement,
        [`${expertiseJudgementAddDocumentIdName}`]: Number(substrings[1]),
        calculatedCompensationAmount: 0,
        [e?.target.name]: e?.target.value,
      },
    ];
  }
  if (civilJudgementIndex === -1) {
    civilJudgement[`${expertise}`] = [
      ...civilJudgement[`${expertise}`],
      {
        [incidentId]: Number(substrings[0]),
        [`${incidentType}`]: incidentElement,
        [`${expertiseJudgementAddDocumentIdName}`]: Number(substrings[1]),
        civilJudgementId: civilJudgement.id,
        calculatedCompensationAmount: 0,
        [e?.target.name]: e?.target.value,
      },
    ];
  } else {
    const currentExpertise =
      civilJudgement[`${expertise}`].find(
        (item: any) =>
          get(item, `${incidentId}`) === Number(substrings[0]) &&
          item[`${expertiseJudgementAddDocumentIdName}`] ===
            Number(substrings[1]),
      ) || {};
    const data =
      civilJudgement[`${expertise}`][
        civilJudgement[`${expertise}`].indexOf(currentExpertise)
      ];
    civilJudgement[`${expertise}`][
      civilJudgement[`${expertise}`].indexOf(currentExpertise)
    ] = {
      ...data,
      ...(incidentType === INCIDENT_TYPE.VEHICLE &&
      expertiseType === CIVIL_JUDGEMENT_TYPES.ACCOUNTING
        ? {
            evaluationAmount:
              e.target.name === 'damageAmount'
                ? e?.target.value
                : get(data, 'damageAmount', data?.evaluationAmount),
          }
        : undefined),
      ...(incidentType === INCIDENT_TYPE.VICTIM &&
      expertiseType === CIVIL_JUDGEMENT_TYPES.ACCOUNTING
        ? {
            calculatedRevenue:
              e.target.name === 'compensationAmount'
                ? e?.target.value
                : get(
                    currentCivilState[`${civj}`][civilStateIndex],
                    'compensationAmount',
                  ),
          }
        : undefined),
      [e.target.name]: e.target.value,
    };
  }
};
export const getDeletedCivilJudgement = (civilJudgements: any) => {
  return civilJudgements
    .flatMap((cj: any) => [...cj.civjacce, ...cj.civjmede])
    .filter((item: any) => item.isDeleted);
};
export const withDeletedCivilJudgement = (civilJudgements: any, vi: any) => {
  return getDeletedCivilJudgement(civilJudgements).some(
    (item: any) =>
      item?.expertiseJudgementAddDocumentId ===
        vi?.expertiseJudgementAddDocumentId && item?.victimId === vi?.victimId,
  );
};
export const withCivilJudgement = (civilJudgements: any, vi: any) => {
  const allCivilJudgements = civilJudgements.flatMap((cj: any) => [
    ...get(cj, 'civjacce', []),
    ...get(cj, 'civjmede', []),
  ]);

  const found =
    allCivilJudgements.find(
      (item: any) =>
        item.expertiseJudgementAddDocumentId ===
          vi.expertiseJudgementAddDocumentId &&
        item.victimId === vi.victimId &&
        !item.isDeleted,
    ) || {};

  return !isEmpty(found);
};
export const filterJudgementAddDocumentsByDate = (
  judgementAddDocuments: any,
  judgementOnMerits: any,
) => {
  return judgementAddDocuments.filter((item: any) => {
    return (
      item.createdAt < get(judgementOnMerits, 'judgementOnMerits.createdAt')
    );
  });
};
export const getJudgementAddDocumentsWithoutCivjs = (
  judgementAddDocuments: any,
  judgementOnMerits: any,
) => {
  return filterJaddByCivjvmAndCivjVehicle(
    filterJudgementAddDocumentsByDate(
      judgementAddDocuments,
      judgementOnMerits,
    ).filter((item: any) => {
      return get(judgementOnMerits, 'judgementOnMerits.jom.civjs', []).every(
        (civj: any) => {
          return civj.judgementAddDocumentId !== item.id;
        },
      );
    }),
    judgementOnMerits,
  );
};
export const filterJaddByCivjvmAndCivjVehicle = (
  judgementAddDocuments: any,
  judgementOnMerits: any,
) => {
  const validVictimIds = get(
    judgementOnMerits,
    'judgementOnMerits.jom.civjvm',
    [],
  ).map((item: any) => item.victimId);
  const validVehicleIds = get(
    judgementOnMerits,
    'judgementOnMerits.jom.civjVehicle',
    [],
  ).map((item: any) => item.vehicleId);

  return judgementAddDocuments
    .map((jadd: any) => ({
      ...jadd,
      expertises: jadd.expertises
        .map((expertise: any) => ({
          ...expertise,
          victims: expertise.victims.filter(
            (victim: VictimType) => !validVictimIds.includes(victim.id),
          ),
          vehicules: expertise.vehicules.filter(
            (vehicle: any) => !validVehicleIds.includes(vehicle.id),
          ),
        }))
        .filter(
          (expertise: any) =>
            !isEmpty(get(expertise, 'victims', [])) ||
            !isEmpty(get(expertise, 'vehicules', [])),
        ),
    }))
    .filter((jaddItem: any) => !isEmpty(get(jaddItem, 'expertises', [])));
};
export const updateVehicleAccountingExpertiseAfterMerge = (
  civilJudgements: any,
  civilJudgementOnMeritsFormAccountingExpertiseData: any,
  meceExp: any,
  type: number,
  e: any,
  accountingExp: any,
) => {
  const accountingCivj = civilJudgements.find(
    (item: any) => item.judgementAddDocumentId === get(accountingExp, 'id'),
  );
  const civilAccountingToUpdate =
    get(accountingCivj, 'civjacce', []).find(
      (item: any) =>
        item.expertiseJudgementAddDocumentId ===
          get(accountingExp, 'expertiseJudgementAddDocumentId') &&
        get(accountingExp, 'vehiculeId') === item.vehiculeId,
    ) || {};
  const expertiseAccounting = civilJudgementOnMeritsFormAccountingExpertiseData.find(
    (item: any) => item.id === get(civilAccountingToUpdate, 'civilJudgementId'),
  );
  const index = civilJudgementOnMeritsFormAccountingExpertiseData.indexOf(
    expertiseAccounting,
  );
  const accExpertise = get(
    civilJudgementOnMeritsFormAccountingExpertiseData[index],
    'accExpertises',
    [],
  ).find((civjacce: any) => civjacce.id === get(civilAccountingToUpdate, 'id'));

  if (index > -1) {
    const civjAccIndex = get(
      civilJudgementOnMeritsFormAccountingExpertiseData[index],
      'accExpertises',
      [],
    ).indexOf(accExpertise);
    civilJudgementOnMeritsFormAccountingExpertiseData[index].accExpertises[
      civjAccIndex
    ] = {
      ...civilJudgementOnMeritsFormAccountingExpertiseData[index].accExpertises[
        civjAccIndex
      ],
      evaluationAmount: type
        ? meceExp.damageAmount
        : e.target.value.replace(',', '.'),
      provisionalExecution: !type
        ? meceExp.provisionalExecution
        : e.target.value.replace(',', '.'),
    };
  }
};
export const addAccountingExpertiseAfterMerge = (
  civilJudgements: any,
  civilJudgementOnMeritsFormAccountingExpertiseData: any,
  medExp: any,
  type: number,
  e: any,
  civjWithoutCompensation: any,
  setCivjvmRequest: Function,
  accountingExp: any,
) => {
  archivateAccountingWithoutCompensation(
    civjWithoutCompensation,
    accountingExp,
    setCivjvmRequest,
    'victimId',
  );

  const accountingCivj = civilJudgements.find(
    (item: any) => item.judgementAddDocumentId === get(accountingExp, 'id'),
  );
  const accountingToAdd = civilJudgementOnMeritsFormAccountingExpertiseData.find(
    (item: any) => item.id === get(accountingCivj, 'id'),
  );
  const civilAccountingToUpdate =
    get(accountingCivj, 'civjacce', []).find(
      (item: any) =>
        item.expertiseJudgementAddDocumentId ===
          get(accountingExp, 'expertiseJudgementAddDocumentId') &&
        get(accountingExp, 'victimId') === item.victimId,
    ) || {};
  if (!isEmpty(civilAccountingToUpdate)) {
    const expertiseAccounting = civilJudgementOnMeritsFormAccountingExpertiseData.find(
      (item: any) =>
        item.id === get(civilAccountingToUpdate, 'civilJudgementId'),
    );
    const index = civilJudgementOnMeritsFormAccountingExpertiseData.indexOf(
      expertiseAccounting,
    );
    const accExpertise = get(
      civilJudgementOnMeritsFormAccountingExpertiseData[index],
      'accExpertises',
      [],
    ).find(
      (civjacce: any) => civjacce.id === get(civilAccountingToUpdate, 'id'),
    );

    if (index > -1) {
      const civjAccIndex = get(
        civilJudgementOnMeritsFormAccountingExpertiseData[index],
        'accExpertises',
        [],
      ).indexOf(accExpertise);
      civilJudgementOnMeritsFormAccountingExpertiseData[index].accExpertises[
        civjAccIndex
      ] = {
        ...civilJudgementOnMeritsFormAccountingExpertiseData[index]
          .accExpertises[civjAccIndex],
        calculatedRevenue:
          type === 0
            ? e.target.value.replace(',', '.')
            : medExp.compensationAmount,
        evaluationAmount:
          type === 2
            ? e.target.value.replace(',', '.')
            : medExp.evaluationAmount,
        provisionalExecution:
          type === 1
            ? e.target.value.replace(',', '.')
            : medExp.provisionalExecution,
      };
    }
  }
  if (!isEmpty(accountingToAdd) && isEmpty(civilAccountingToUpdate)) {
    const index = civilJudgementOnMeritsFormAccountingExpertiseData.indexOf(
      accountingToAdd,
    );
    const updatedData = {
      calculatedRevenue:
        type === 0
          ? e.target.value.replace(',', '.')
          : medExp.compensationAmount,
      evaluationAmount:
        type === 2 ? e.target.value.replace(',', '.') : medExp.evaluationAmount,
      provisionalExecution:
        type === 1
          ? e.target.value.replace(',', '.')
          : medExp.provisionalExecution,
      victimId: get(accountingExp, 'victimId'),
      expertiseJudgementAddDocumentId: get(
        accountingExp,
        'expertiseJudgementAddDocumentId',
      ),
      civilJudgementId: get(accountingToAdd, 'id'),
    };
    const existingIndex = civilJudgementOnMeritsFormAccountingExpertiseData[
      index
    ]['accExpertises'].findIndex(
      (item: any) => item.victimId === updatedData.victimId,
    );

    if (existingIndex > -1) {
      civilJudgementOnMeritsFormAccountingExpertiseData[index]['accExpertises'][
        existingIndex
      ] = {
        ...civilJudgementOnMeritsFormAccountingExpertiseData[index][
          'accExpertises'
        ][existingIndex],
        ...updatedData,
      };
    } else {
      civilJudgementOnMeritsFormAccountingExpertiseData[index][
        'accExpertises'
      ].push(updatedData);
    }
  }
};
export const archivateAccountingWithoutCompensation = (
  civjWithoutCompensation: any,
  accountingExp: any,
  setCivjvmRequest: any,
  incidentType: string,
) => {
  const accountingExpertiseWithoutCompensation = civjWithoutCompensation.find(
    (item: any) =>
      item?.expertiseJudgementAddDocumentId ===
        get(accountingExp, 'expertiseJudgementAddDocumentId') &&
      get(item, `${incidentType}`) === get(accountingExp, `${incidentType}`),
  );
  if (!isEmpty(accountingExpertiseWithoutCompensation)) {
    civjWithoutCompensation[
      civjWithoutCompensation.indexOf(accountingExpertiseWithoutCompensation)
    ] = { ...accountingExpertiseWithoutCompensation, isDeleted: true };

    setCivjvmRequest(civjWithoutCompensation);
  }
};
export const getJudgementAddDocument = (
  civilJudgement: any,
  judgementAddDocuments: any,
  victimExpertises: any,
  vehicleExpertises: any,
) => {
  const formattedAdd = formatExpertisesWithExpertReport(
    judgementAddDocuments,
    victimExpertises,
    vehicleExpertises,
  );
  return (
    formattedAdd.find(
      (item: any) => item.id === get(civilJudgement, 'judgementAddDocumentId'),
    ) || {}
  );
};

export const isBeneficiaryNotEmpty = (beneficiaryContestationReasons: any) => {
  if (!isEmpty(Array.from(beneficiaryContestationReasons))) {
    const beneficiaryContestationReason = Array.from(
      beneficiaryContestationReasons,
    ).map((el: any) => !isEmpty(Array.from(el.reasons)));
    if (beneficiaryContestationReason.includes(true)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
export const reasonWithoutCompensationConditions = (
  item: any,
  judgement: any,
  civjvmRequest: any,
  deceasedVictim: VictimType,
  civilJudgementVictimReason: Config[] = [],
) => {
  const baseKeyPattern = new RegExp(`-${item.victimId}$`);
  const matchingKey = Object.keys(judgement).find(key =>
    baseKeyPattern.test(key),
  );
  return featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION)
    ? isEmpty(deceasedVictim)
      ? (matchingKey &&
          !get(judgement[matchingKey], 'formRejectionRecap', false) &&
          !get(judgement[matchingKey], 'formRejection', false)) ||
        isCivilJudgementVictimSubstantive(
          civilJudgementVictimReason,
          item,
          civjvmRequest,
        )
      : !isNextOfKinsWithFormRejection(
          get(deceasedVictim, 'beneficiaries', []),
          civilJudgementVictimReason,
        )
    : true;
};
export const getAllBeneficiaries = (deceasedVictim: VictimType[]) => {
  return deceasedVictim?.flatMap((item: any) => get(item, 'beneficiaries', []));
};
export const findInjuredVictimsWithoutJadd = (
  victims: Victim[],
  judgementAddDocuments: any,
  associatedVictims?: any,
  creationDateJom?: any,
) => {
  const injuredVictims = victims.filter(
    (item: Victim) =>
      creationDateJom &&
      new Date(get(item, 'CivilDocumentVictim.createdAt')) <
        new Date(creationDateJom) &&
      get(item, 'injuryPostKey') !== INJURY_POST_DECEASED &&
      (!isEmpty(associatedVictims)
        ? associatedVictims.includes(item.id)
        : true),
  );
  const jaddVictims = flatMap(judgementAddDocuments, (item: any) =>
    flatMap(get(item, 'expertises', []), expertise =>
      get(expertise, 'victims', []),
    ),
  );
  return differenceBy(injuredVictims, jaddVictims, 'id');
};
export const areAllVictimsInCivjvmRecap = (
  victims: Victim[],
  civjvm: any,
  judgementAddDocuments: any,
  civilJudgementVictimReason: Config[],
  creationDateJom: any,
  associatedVictims?: any,
) => {
  const injuredVictims = findInjuredVictimsWithoutJadd(
    victims,
    judgementAddDocuments,
    associatedVictims,
    creationDateJom,
  );
  const civjvmWithoutExpertise = civjvm.filter(
    (item: any) => !item?.expertiseJudgementAddDocumentId,
  );
  return (
    !isEmpty(injuredVictims) &&
    !injuredVictims.every(victim => {
      return civjvmWithoutExpertise.some((civ: any) => {
        return (
          civ.victimId === victim.id &&
          !isNil(get(civ, 'reasonId')) &&
          (hasOtherReason(civilJudgementVictimReason, get(civ, 'reasonId'))
            ? !isEmpty(get(civ, 'otherReason', ''))
            : true)
        );
      });
    })
  );
};

export const areAllVictimsInCivjvmAdd = (
  victims: Victim[],
  civjvm: any,
  judgementAddDocuments: any,
  civilJudgementVictimReason: Config[],
  associatedVictims?: any,
) => {
  const injuredVictims = findInjuredVictimsWithoutJadd(
    victims,
    judgementAddDocuments,
    associatedVictims,
  );
  const civjvmWithoutExpertise = civjvm.filter(
    (item: any) => !item?.expertiseJudgementAddDocumentId && !item?.id,
  );
  return (
    !isEmpty(injuredVictims) &&
    !injuredVictims.every(victim => {
      return civjvmWithoutExpertise.some((civ: any) => {
        return (
          civ.victimId === victim.id &&
          !isNil(get(civ, 'reasonId')) &&
          (hasOtherReason(civilJudgementVictimReason, get(civ, 'reasonId'))
            ? !isEmpty(get(civ, 'otherReason', ''))
            : true)
        );
      });
    })
  );
};

export const mapJudiciaryProcessEvaluations = (
  currentJudiciaryProcess: any,
  beneficiaries: any,
  sagisEvalVictimKeys: any,
  civilDocumentsVictimKeys: any,
  victimsEvaluationsToInclude: any,
  deceasedVictim: VictimType[],
  judgementOnMeritsRequest: any,
  judgementOnMerits: any,
  additionalJudgementOnMeritsInfoForm: any,
  judgementOnMeritsInfoForm: any,
  claim: any,
  civilProceedingVictims: any,
  civilJudgementVictimReasonListing: any,
  isMultiple: any,
  judiciaryProcessId: any,
) => {
  return get(currentJudiciaryProcess, 'victims', [])
    .filter((v: any) => {
      const victimBeneficiaries = beneficiaries.filter(
        (beneficiary: any) => beneficiary?.victimId === v?.id,
      );
      return (
        v[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2' &&
        !sagisEvalVictimKeys.includes(v.victimKey) &&
        !civilDocumentsVictimKeys.includes(v.victimKey) &&
        isJomAssociatedVictimsIncluded(
          isMultiple,
          get(v, 'id'),
          victimsEvaluationsToInclude,
        ) &&
        !isNextOfKinsWithFormRejection(
          victimBeneficiaries,
          civilJudgementVictimReasonListing,
        )
      );
    })
    .map((victim: VictimType) => {
      const currentVictim = deceasedVictim.find(
        (el: any) => el.victimId === victim.id,
      );

      const jmv =
        get(judgementOnMeritsRequest, 'jmv', []).find(
          (item: JudgementOnMeritsVictim) =>
            item.victimId === get(victim, 'victimId', victim?.id),
        ) || {};

      return (
        checkVictimExistanceCivilPartyById(
          victim[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          civilProceedingVictims,
        ).includes(true) && {
          gestionMode: '',
          materialAmount: '',
          currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
          judiciaryAmount: isNextOfKinsSubstantive(
            get(currentVictim, 'beneficiaries', []),
            civilJudgementVictimReasonListing,
          )
            ? 0
            : !isNil(get(jmv, 'compensationAmount', null))
            ? Number(get(jmv, 'compensationAmount'))
            : get(victim, 'judiciaryAmount', ''),
          responsibilityRate: victim['responsibilityShare'],
          rateRecovery: null,
          revenu: !isNil(
            getVictimRevenu(
              victim[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
              civilProceedingVictims,
              judiciaryProcessId,
            ),
          )
            ? getVictimRevenu(
                victim[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                civilProceedingVictims,
                judiciaryProcessId,
              )
            : victim['annualOfIncome'],
          age: getVictimAge(
            victim['id'],
            civilProceedingVictims,
            claim['lossDate'],
          ),
          lossDate: moment(claim['lossDate']).toISOString(true),
          mode: MODE.DECEASED,
          funeralFeesAmount: get(jmv, 'funeralFees', null),
          medicalFeesAmount: get(jmv, 'medicalFees', null),
          ratePretium: null,
          rateAestheticDamageWithoutConsequence: null,
          rateAestheticDamageWithConsequence: null,
          rateCareerPrejudice: null,
          rateSchoolingPrejudice: null,
          rateIPP: null,
          rateITT: null,
          victimKey: victim['victimKey'],
          medicalPharmaceuticalFees: null,
          rateMedicalPharmaceuticalFees: '',
          transactionPhase: 1,
          isJusticeFeesChecked:
            resolveValueFromForm(
              get(additionalJudgementOnMeritsInfoForm, 'responsibility', ''),
              get(
                judgementOnMerits,
                'judgementOnMerits.jom.responsibility',
                '',
              ),
            ) === 'Oui'
              ? true
              : false,
          isIDDChecked:
            resolveValueFromForm(
              get(additionalJudgementOnMeritsInfoForm, 'idd', ''),
              get(judgementOnMerits, 'judgementOnMerits.jom.idd', ''),
            ) === 'Oui'
              ? true
              : false,
          iddEffectiveDate: resolveCalculationStartDate(
            get(additionalJudgementOnMeritsInfoForm, 'calculationStartDate'),
            get(
              judgementOnMerits,
              'judgementOnMerits.jom.calculationStartDate',
              '',
            ),
          ),
          JudiciartDecisionDate: !isEmpty(
            get(judgementOnMeritsInfoForm, 'judgementDate', ''),
          )
            ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
            : get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate', ''),
        }
      );
    });
};

export const mapCivilDocumentsEvaluations = (
  deceasedVictim: VictimType[],
  sagisEvalVictimKeys: any,
  victimsEvaluationsToInclude: any,
  judgementOnMeritsRequest: any,
  claim: any,
  additionalJudgementOnMeritsInfoForm: any,
  judgementOnMerits: any,
  judgementOnMeritsInfoForm: any,
  civilProceedingVictims: any,
  civilJudgementVictimReasonListing: any,
  isMultiple: any,
  judiciaryProcessId: any,
) => {
  return checkVictimExistanceCivilParty(
    deceasedVictim,
    civilProceedingVictims,
  ) &&
    checkVictimExistanceCivilParty(
      deceasedVictim,
      civilProceedingVictims,
    ).includes(true)
    ? deceasedVictim
        .filter(
          (v: any) =>
            !sagisEvalVictimKeys.includes(v.victimKey) &&
            isJomAssociatedVictimsIncluded(
              isMultiple,
              get(v, 'victimId'),
              victimsEvaluationsToInclude,
            ) &&
            !isNextOfKinsWithFormRejection(
              get(v, 'beneficiaries', []),
              civilJudgementVictimReasonListing,
            ),
        )
        .map((victim: VictimType) => {
          const jmv =
            get(judgementOnMeritsRequest, 'jmv', []).find(
              (item: JudgementOnMeritsVictim) =>
                item.victimId === victim.victimId,
            ) || {};

          return {
            judiciaryAmount: isNextOfKinsSubstantive(
              get(victim, 'beneficiaries', []),
              civilJudgementVictimReasonListing,
            )
              ? 0
              : !isNil(get(jmv, 'compensationAmount', null))
              ? Number(get(jmv, 'compensationAmount'))
              : get(victim, 'judiciaryAmount', null),
            gestionMode: '',
            materialAmount: '',
            currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
            responsibilityRate: victim['responsibilityShare'],
            rateRecovery: null,
            revenu: !isNil(
              getVictimRevenu(
                victim[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                civilProceedingVictims,
                judiciaryProcessId,
              ),
            )
              ? getVictimRevenu(
                  victim[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                  civilProceedingVictims,
                  judiciaryProcessId,
                )
              : victim['annualOfIncome'],
            age: getDeceasedVictimAge(
              (victim['victimId'] as unknown) as string,
              deceasedVictim,
              claim['lossDate'],
            ),
            mode: MODE.DECEASED,
            lossDate: moment(claim['lossDate']).toISOString(true),
            funeralFeesAmount: get(jmv, 'funeralFees', null),
            medicalFeesAmount: get(jmv, 'medicalFees', null),
            ratePretium: null,
            rateAestheticDamageWithoutConsequence: null,
            rateAestheticDamageWithConsequence: null,
            rateCareerPrejudice: null,
            rateSchoolingPrejudice: null,
            rateIPP: null,
            rateITT: null,
            victimKey: victim['victimKey'],
            medicalPharmaceuticalFees: null,
            rateMedicalPharmaceuticalFees: '',
            transactionPhase: 1,
            isJusticeFeesChecked:
              resolveValueFromForm(
                get(additionalJudgementOnMeritsInfoForm, 'responsibility', ''),
                get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.responsibility',
                  '',
                ),
              ) === 'Oui'
                ? true
                : false,
            isIDDChecked:
              resolveValueFromForm(
                get(additionalJudgementOnMeritsInfoForm, 'idd', ''),
                get(judgementOnMerits, 'judgementOnMerits.jom.idd', ''),
              ) === 'Oui'
                ? true
                : false,
            iddEffectiveDate: resolveCalculationStartDate(
              get(additionalJudgementOnMeritsInfoForm, 'calculationStartDate'),
              get(
                judgementOnMerits,
                'judgementOnMerits.jom.calculationStartDate',
                '',
              ),
            ),
            JudiciartDecisionDate: !isEmpty(
              get(judgementOnMeritsInfoForm, 'judgementDate', ''),
            )
              ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
              : get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.judgementDate',
                  '',
                ),
          };
        })
    : [];
};

export const mapReasonWithoutCompensationEvaluations = (
  civjvmRequest: any,
  sharedResponsability: any,
  claim: any,
  judgementOnMeritsInfo: any,
  judgementOnMeritsInfoForm: any,
  judgementOnMerits: any,
  civilProceedingVictims: any,
  civilJudgementVictimReasonListing: any,
  expertiseReport: any,
  dahirAmount?: any,
) => {
  return getSubstantiveWithoutCompensation(
    civilJudgementVictimReasonListing,
    civjvmRequest,
  ).map((item: any) => {
    const lastMedicalExpertise =
      get(expertiseReport, 'victimExpertises', []).find(
        (el: any) =>
          String(el?.victimId) === String(item?.victimId) &&
          !el.isOld &&
          el.status !== GLOBAL_STATUS.PENDING &&
          el.status !== GLOBAL_STATUS.REJECTED &&
          !el.isRejectedJudgement &&
          String(el.expertiseId) === MEDICAL_EXPERTISE_ID,
      ) || {};
    const lastEvaluation = getTheLatestEvaluationObject(
      getVictimKey(
        item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
        civilProceedingVictims || (([] as unknown) as VictimType[]),
      ),
      dahirAmount,
    );
    return (
      checkVictimExistanceCivilPartyById(
        item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
        civilProceedingVictims,
      ).includes(true) && {
        gestionMode: '',
        materialAmount: '',
        currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
        judiciaryAmount: 0,
        responsibilityRate: sharedResponsability,
        age: getVictimAge(
          item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          civilProceedingVictims,
          claim['lossDate'],
        ),
        revenu: getVictimRevenu(
          item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          civilProceedingVictims,
        ),
        mode: MODE.BLESSE,
        lossDate: moment(claim['lossDate']).toISOString(true),
        rateITT: featureService.hasFeature(
          FEATURES.RESOLVE_EXPERTISE_REPORT_VALUES,
        )
          ? resolveExpertiseValue(
              item,
              get(item, 'victim.itt'),
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.ITT],
              get(lastEvaluation, 'rateITT'),
            )
          : get(item, 'victim.itt'),
        victimKey: getVictimKey(
          item[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
          civilProceedingVictims,
        ),
        rateMedicalPharmaceuticalFees: '',
        transactionPhase: 1,
        isJusticeFeesChecked:
          get(judgementOnMeritsInfo, 'responsibility', '') === 'Oui'
            ? true
            : false,
        isIDDChecked:
          get(judgementOnMeritsInfo, 'idd', '') === 'Oui' ? true : false,
        iddEffectiveDate: get(judgementOnMeritsInfo, 'calculationStartDate'),
        JudiciartDecisionDate: !isEmpty(
          get(judgementOnMeritsInfoForm, 'judgementDate', ''),
        )
          ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
          : get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate', ''),
      }
    );
  });
};
const formatEvaluations = (
  victimIds: any,
  judgementOnMerits: any,
  judgementOnMeritsRequest: any,
  victims: any,
  civilJudgementOnMeritsFormMedicalExpertise: any,
  sharedResponsability: any,
  civilJudgementOnMeritsFormAccountingExpertise: any,
) => {
  return victimIds.map((id: number) => {
    let judiciaryAmount = null;
    let revenu = null;
    let itt = null;
    let expertiseJudgementAddDocumentId = null;
    let expertiseId = null;
    const victim = victims.find((item: any) => Number(item.id) === Number(id));
    [
      ...get(judgementOnMerits, 'judgementOnMerits.jom.civjs', []),
      ...get(judgementOnMeritsRequest, 'civjs', []),
    ].forEach((el: any) => {
      const civjId = get(el, 'id');
      let found = get(el, 'civjmede', []).find((el: any) => el.victimId === id);
      if (found) {
        const jomMedExpertise =
          civilJudgementOnMeritsFormMedicalExpertise.find(
            (el: any) => el.id === civjId,
          ) || {};
        judiciaryAmount = !isEmpty(jomMedExpertise)
          ? get(
              get(jomMedExpertise, 'medExpertises', []).find(
                (el: any) => el.id === get(found, 'id'),
              ),
              'compensationAmount',
            )
          : get(found, 'compensationAmount');
        expertiseJudgementAddDocumentId = get(
          found,
          'expertiseJudgementAddDocumentId',
        );
        expertiseId = EXPERTISE_MEDICAL_ID;
        itt = get(found, 'victim.itt', victim?.itt);
      } else {
        found = get(el, 'civjacce', []).find((el: any) => el.victimId === id);
        if (found) {
          const jomAccExpertise =
            civilJudgementOnMeritsFormAccountingExpertise.find(
              (el: any) => el.id === civjId,
            ) || {};
          judiciaryAmount = !isEmpty(jomAccExpertise)
            ? get(
                get(jomAccExpertise, 'accExpertises', []).find(
                  (el: any) => el.id === get(found, 'id'),
                ),
                'calculatedRevenue',
                '',
              )
            : get(found, 'calculatedRevenue');
          expertiseJudgementAddDocumentId = get(
            found,
            'expertiseJudgementAddDocumentId',
          );
          expertiseId = EXPERTISE_ACCOUNTING_ID;
          itt = get(found, 'victim.itt', victim?.itt);
        }
      }
    });
    [
      ...get(judgementOnMerits, 'judgementOnMerits.jom.civjs', []),
      ...get(judgementOnMeritsRequest, 'civjs', []),
    ].forEach((el: any) => {
      const civjId = get(el, 'id');
      let found = get(el, 'civjacce', []).find((el: any) => el.victimId === id);
      if (found) {
        const jomAccExpertise =
          civilJudgementOnMeritsFormAccountingExpertise.find(
            (el: any) => el.id === civjId,
          ) || {};
        revenu = !isEmpty(jomAccExpertise)
          ? get(
              get(jomAccExpertise, 'accExpertises', []).find(
                (el: any) => el.id === get(found, 'id'),
              ),
              'evaluationAmount',
            )
          : get(found, 'evaluationAmount');
        expertiseJudgementAddDocumentId = get(
          found,
          'expertiseJudgementAddDocumentId',
        );
        expertiseId = EXPERTISE_ACCOUNTING_ID;
      }
    });
    return {
      victimId: id,
      judiciaryAmount,
      responsibilityShare: sharedResponsability,
      revenu,
      itt,
      expertiseJudgementAddDocumentId,
      expertiseId,
    };
  });
};

export const mapSagisEvaluationWithoutExpertise = (
  victims: any,
  expertiseReport: any,
  judgementOnMerits: any,
  judgementOnMeritsRequest: any,
  civilJudgementOnMeritsFormMedicalExpertise: any,
  sharedResponsability: any,
  civilJudgementOnMeritsFormAccountingExpertise: any,
  judgement: any,
  civjvmRequest: any,
  newCivjvm: any,
  additionalJudgementOnMeritsInfoForm: any,
  judgementOnMeritsInfoForm: any,
  claim: any,
  civilProceedingVictims: any,
  civilJudgementVictimReasonListing: any,
  judgementAddDocuments: any,
  judiciaryProcessId: any,
  dahirAmount?: any,
) => {
  return formatEvaluations(
    difference(
      [
        ...uniq(getVictimIds(judgementAddDocuments)).filter(
          (id: any) =>
            ![
              ...victims
                .filter((v: any) => v.injuryPostKey === INJURY_POST_DECEASED)
                .map((v: any) => v.id),
            ].includes(id),
        ),
      ],
      get(expertiseReport, 'victimExpertises', []).map(
        (el: any) => el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
      ),
    ),
    judgementOnMerits,
    judgementOnMeritsRequest,
    victims,
    civilJudgementOnMeritsFormMedicalExpertise,
    sharedResponsability,
    civilJudgementOnMeritsFormAccountingExpertise,
  )
    .filter((item: any) => {
      return reasonWithoutCompensationConditions(
        item,
        judgement,
        [...civjvmRequest, ...newCivjvm],
        ([] as unknown) as VictimType,
        civilJudgementVictimReasonListing,
      );
    })
    .map((el: any) => {
      const lastEvaluation = getTheLatestEvaluationObject(
        getVictimKey(
          el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
          victims || (([] as unknown) as VictimType[]),
        ),
        dahirAmount,
      );
      return (
        checkVictimExistanceCivilPartyById(
          el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          civilProceedingVictims,
        ).includes(true) && {
          gestionMode: '',
          materialAmount: '',
          currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
          judiciaryAmount: isCivilJudgementVictimSubstantive(
            civilJudgementVictimReasonListing,
            el,
            [...civjvmRequest, ...newCivjvm],
          )
            ? 0
            : el['judiciaryAmount'],
          responsibilityRate: el['responsibilityShare'],
          revenu: !isNil(
            getVictimRevenu(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
              victims,
              judiciaryProcessId,
            ),
          )
            ? getVictimRevenu(
                el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                victims,
                judiciaryProcessId,
              )
            : el['revenu'],
          age: getVictimAge(
            el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
            victims,
            claim['lossDate'],
          ),
          mode: MODE.BLESSE,
          lossDate: moment(claim['lossDate']).toISOString(true),
          rateITT: featureService.hasFeature(
            FEATURES.RESOLVE_EXPERTISE_REPORT_VALUES,
          )
            ? el[VICTIM_EXPERTISE_FIELDS.ITT]
              ? el[VICTIM_EXPERTISE_FIELDS.ITT]
              : String(get(lastEvaluation, 'rateITT'))
            : el[VICTIM_EXPERTISE_FIELDS.ITT],
          victimKey: getVictimKey(
            el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
            victims,
          ),
          // rateMedicalPharmaceuticalFees: '',
          transactionPhase: 1,
          isJusticeFeesChecked:
            resolveValueFromForm(
              get(additionalJudgementOnMeritsInfoForm, 'responsibility', ''),
              get(
                judgementOnMerits,
                'judgementOnMerits.jom.responsibility',
                '',
              ),
            ) === 'Oui'
              ? true
              : false,
          isIDDChecked:
            resolveValueFromForm(
              get(additionalJudgementOnMeritsInfoForm, 'idd', ''),
              get(judgementOnMerits, 'judgementOnMerits.jom.idd', ''),
            ) === 'Oui'
              ? true
              : false,
          iddEffectiveDate: resolveCalculationStartDate(
            get(additionalJudgementOnMeritsInfoForm, 'calculationStartDate'),
            get(
              judgementOnMerits,
              'judgementOnMerits.jom.calculationStartDate',
              '',
            ),
          ),
          JudiciartDecisionDate: !isEmpty(
            get(judgementOnMeritsInfoForm, 'judgementDate', ''),
          )
            ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
            : get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate', ''),
        }
      );
    });
};
const resolveLawyerCompensationAmount = (
  el: any,
  desceasedVictims: any,
  civilJudgements: any,
  judgementOnMeritsRequest: any,
  civilJudgementOnMeritsFormMedicalExpertise: any,
  civilJudgementOnMeritsFormAccountingExpertise: any,
  civilJudgementVictimReasonListing: any,
) => {
  const civj = getCivilJudgementByVictimId(
    [...civilJudgements, ...get(judgementOnMeritsRequest, 'civjs', [])],
    el,
  );

  let deceasedVictim = null;
  let victim = null;
  if (el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2') {
    const jmv =
      get(judgementOnMeritsRequest, 'jmv', []).find(
        (item: JudgementOnMeritsVictim) => item.victimId === el.victimId,
      ) || {};
    deceasedVictim =
      desceasedVictims.find((item: any) => item.victimId === el.victimId) || {};

    return isNextOfKinsSubstantive(
      get(deceasedVictim, 'beneficiaries', []),
      civilJudgementVictimReasonListing,
    )
      ? 0
      : !isNil(get(jmv, 'compensationAmount', null))
      ? get(jmv, 'compensationAmount', null)
      : get(deceasedVictim, 'judiciaryAmount');
  }
  if (el.expertiseId === 1) {
    const victim = civj.find(cj => !isEmpty(cj.civjmede));
    const civId = get(victim, 'civjmede[0].civilJudgementId', '');
    const civMedId = get(victim, 'civjmede[0].id', '');
    const jomMedExpertise = civilJudgementOnMeritsFormMedicalExpertise.find(
      (el: any) => el.id === civId,
    );
    const expertise = !isEmpty(get(jomMedExpertise, 'medExpertises', []))
      ? get(jomMedExpertise, 'medExpertises', []).find(
          (el: any) => el.id === civMedId,
        )
      : get(victim, 'civjmede[0]', {});
    return get(expertise, 'compensationAmount', '');
  }

  victim = civj.find(cj => !isEmpty(cj.civjacce));
  const civId = get(victim, 'civjacce[0].civilJudgementId', '');
  const civAccId = get(victim, 'civjacce[0].id', '');
  const jomAccExpertise = civilJudgementOnMeritsFormAccountingExpertise.find(
    (el: any) => el.id === civId,
  );
  const expertise = !isEmpty(get(jomAccExpertise, 'accExpertises', []))
    ? get(jomAccExpertise, 'accExpertises', []).find(
        (el: any) => el.id === civAccId,
      )
    : get(victim, 'civjacce[0]', {});
  return get(expertise, 'calculatedRevenue', '');
};
const resolveRevenu = (
  el: any,
  civilJudgements: any,
  judgementOnMeritsRequest: any,
  civilJudgementOnMeritsFormAccountingExpertise: any,
) => {
  const civj = getCivilJudgementByVictimId(
    [...civilJudgements, ...get(judgementOnMeritsRequest, 'civjs', [])],
    el,
  );
  if (el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2')
    return el[VICTIM_EXPERTISE_FIELDS.FIXED_ANNUAL_INCOME];
  if (el.expertiseId === 2) {
    const victim = civj.find(civj => !isEmpty(civj.civjacce));
    const civId = get(victim, 'civjacce[0].civilJudgementId', '');
    const civAccId = get(victim, 'civjacce[0].id', '');
    const jomAccExpertise = civilJudgementOnMeritsFormAccountingExpertise.find(
      (el: any) => el.id === civId,
    );
    const expertise = !isEmpty(get(jomAccExpertise, 'accExpertises', []))
      ? get(jomAccExpertise, 'accExpertises', []).find(
          (el: any) => el.id === civAccId && !get(el, 'isDeleted', false),
        )
      : get(victim, 'civjacce', []).find(
          item => !get(item, 'isDeleted', false),
        );
    return get(expertise, 'evaluationAmount', el?.fixedAnnualIncome);
  }
};

export const getRateItt = (
  el: any,
  lastMedicalExpertise: any,
  lastEvaluation: any,
) => {
  if (
    String(el.expertiseId) === COMPTABLE_EXPERTISE_ID &&
    isEmpty(lastMedicalExpertise)
  ) {
    const itt =
      !isEmpty(lastEvaluation) && String(get(lastEvaluation, 'rateITT'))
        ? String(get(lastEvaluation, 'rateITT'))
        : el.previousItt;
    return itt;
  } else {
    return resolveExpertiseValue(
      el,
      el[VICTIM_EXPERTISE_FIELDS.ITT],
      lastMedicalExpertise,
      lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.ITT],
      lastEvaluation.rateITT,
    );
  }
};

export const mapSagisEvaluation = (
  expertiseReport: any,
  deceasedVictim: VictimType[],
  victimsEvaluationsToInclude: any,
  judgement: any,
  civjvmRequest: any,
  newCivjvm: any,
  civilJudgements: any,
  judgementOnMeritsRequest: any,
  civilJudgementOnMeritsFormMedicalExpertise: any,
  civilJudgementOnMeritsFormAccountingExpertise: any,
  civilJudgementOnMeritsForm: any,
  responsibilityRate: any,
  victims: any,
  additionalJudgementOnMeritsInfoForm: any,
  claim: any,
  judgementOnMerits: any,
  judgementOnMeritsInfoForm: any,
  civilProceedingVictims: any,
  civilJudgementVictimReasonListing: any,
  isMultiple: any,
  judiciaryProcessId: any,
  dahirAmount?: any,
) => {
  return get(expertiseReport, 'victimExpertises', [])
    .filter((vi: any) => {
      const victim: VictimType | {} =
        deceasedVictim.find(
          (item: VictimType) => item?.victimId === vi?.victimId,
        ) || {};
      return (
        !vi.isOld &&
        isJomAssociatedVictimsIncluded(
          isMultiple,
          vi[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          victimsEvaluationsToInclude,
        ) &&
        reasonWithoutCompensationConditions(
          vi,
          judgement,
          [...civjvmRequest, ...newCivjvm],
          (victim as unknown) as VictimType,
          civilJudgementVictimReasonListing,
        )
      );
    })
    .map((el: any) => {
      const lastMedicalExpertise =
        get(expertiseReport, 'victimExpertises', []).find(
          (item: any) =>
            String(item?.victimId) === String(el?.victimId) &&
            !item.isOld &&
            item.status !== GLOBAL_STATUS.PENDING &&
            item.status !== GLOBAL_STATUS.REJECTED &&
            !item.isRejectedJudgement &&
            String(item.expertiseId) === MEDICAL_EXPERTISE_ID,
        ) || {};
      const lastEvaluation = getTheLatestEvaluationObject(
        getVictimKey(
          el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
          victims || (([] as unknown) as VictimType[]),
        ),
        dahirAmount,
      );
      const objectToReturn = featureService.hasFeature(
        FEATURES.RESOLVE_EXPERTISE_REPORT_VALUES,
      )
        ? {
            gestionMode: '',
            materialAmount: '',
            currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
            judiciaryAmount: isCivilJudgementVictimSubstantive(
              civilJudgementVictimReasonListing,
              el,
              [...civjvmRequest, ...newCivjvm],
            )
              ? 0
              : resolveLawyerCompensationAmount(
                  el,
                  deceasedVictim,
                  civilJudgements,
                  judgementOnMeritsRequest,
                  civilJudgementOnMeritsFormMedicalExpertise,
                  civilJudgementOnMeritsFormAccountingExpertise,
                  civilJudgementVictimReasonListing,
                ),
            responsibilityRate: getResponsabilityShare(
              civilJudgements,
              el,
              deceasedVictim,
              expertiseReport.victimExpertises,
              civilJudgementOnMeritsForm,
              responsibilityRate,
            ),
            funeralFeesAmount:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? get(
                    resolveDeceasedVictimFees(
                      el,
                      get(judgementOnMeritsRequest, 'jmv', []),
                    ),
                    'funeralFees',
                    null,
                  )
                : undefined,
            medicalFeesAmount:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? get(
                    resolveDeceasedVictimFees(
                      el,
                      get(judgementOnMeritsRequest, 'jmv', []),
                    ),
                    'medicalFees',
                    null,
                  )
                : undefined,
            rateRecovery: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL],
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL],
              lastEvaluation.rateRecovery,
            ),
            revenu: !isNil(
              getVictimRevenu(
                el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                victims,
                judiciaryProcessId,
              ),
            )
              ? getVictimRevenu(
                  el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                  victims,
                  judiciaryProcessId,
                )
              : el.expertiseId === 1
              ? el[VICTIM_EXPERTISE_FIELDS.VICTIM_REVENUE]
              : resolveRevenu(
                  el,
                  civilJudgements,
                  judgementOnMeritsRequest,
                  civilJudgementOnMeritsFormAccountingExpertise,
                ),
            age: getVictimAge(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
              victims,
              claim['lossDate'],
            ),
            lossDate: moment(claim['lossDate']).toISOString(true),
            mode:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? MODE.DECEASED
                : MODE.BLESSE,
            ratePretium: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS],
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS],
              get(lastEvaluation, 'ratePretium'),
            ),
            rateAestheticDamageWithoutConsequence: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE],
              lastMedicalExpertise,
              lastMedicalExpertise[
                VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE
              ],
              lastEvaluation.rateAestheticDamageWithoutConsequence,
            ),
            rateAestheticDamageWithConsequence: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE],
              lastMedicalExpertise,
              lastMedicalExpertise[
                VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE
              ],
              lastEvaluation.rateAestheticDamageWithConsequence,
            ),
            rateCareerPrejudice: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE],
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE],
              lastEvaluation.rateCareerPrejudice,
            ),
            rateSchoolingPrejudice: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE],
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE],
              lastEvaluation.rateSchoolingPrejudice,
            ),
            rateIPP: resolveExpertiseValue(
              el,
              el[VICTIM_EXPERTISE_FIELDS.IPP],
              lastMedicalExpertise,
              lastMedicalExpertise[VICTIM_EXPERTISE_FIELDS.IPP],
              lastEvaluation.rateIPP,
            ),
            rateITT: getRateItt(el, lastMedicalExpertise, lastEvaluation),
            victimKey: getVictimKey(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
              victims,
            ),
            medicalPharmaceuticalFees:
              el[VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES],
            // rateMedicalPharmaceuticalFees: '',
            transactionPhase: 1,
            isJusticeFeesChecked:
              resolveValueFromForm(
                get(additionalJudgementOnMeritsInfoForm, 'responsibility', ''),
                get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.responsibility',
                  '',
                ),
              ) === 'Oui'
                ? true
                : false,
            isIDDChecked:
              resolveValueFromForm(
                get(additionalJudgementOnMeritsInfoForm, 'idd', ''),
                get(judgementOnMerits, 'judgementOnMerits.jom.idd', ''),
              ) === 'Oui'
                ? true
                : false,

            iddEffectiveDate: resolveCalculationStartDate(
              get(additionalJudgementOnMeritsInfoForm, 'calculationStartDate'),
              get(
                judgementOnMerits,
                'judgementOnMerits.jom.calculationStartDate',
                '',
              ),
            ),
            JudiciartDecisionDate: !isEmpty(
              get(judgementOnMeritsInfoForm, 'judgementDate', ''),
            )
              ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
              : get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.judgementDate',
                  '',
                ),
            expType: Number(el.expertiseId),
            isRecentExpertiseVictim: el.isRecentExpertiseVictim,
          }
        : {
            gestionMode: '',
            materialAmount: '',
            currentJudiciaryStep: CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS,
            judiciaryAmount: isCivilJudgementVictimSubstantive(
              civilJudgementVictimReasonListing,
              el,
              [...civjvmRequest, ...newCivjvm],
            )
              ? 0
              : resolveLawyerCompensationAmount(
                  el,
                  deceasedVictim,
                  civilJudgements,
                  judgementOnMeritsRequest,
                  civilJudgementOnMeritsFormMedicalExpertise,
                  civilJudgementOnMeritsFormAccountingExpertise,
                  civilJudgementVictimReasonListing,
                ),
            responsibilityRate: getResponsabilityShare(
              civilJudgements,
              el,
              deceasedVictim,
              expertiseReport.victimExpertises,
              civilJudgementOnMeritsForm,
              responsibilityRate,
            ),
            funeralFeesAmount:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? get(
                    resolveDeceasedVictimFees(
                      el,
                      get(judgementOnMeritsRequest, 'jmv', []),
                    ),
                    'funeralFees',
                    null,
                  )
                : undefined,
            medicalFeesAmount:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? get(
                    resolveDeceasedVictimFees(
                      el,
                      get(judgementOnMeritsRequest, 'jmv', []),
                    ),
                    'medicalFees',
                    null,
                  )
                : undefined,
            rateRecovery: el[VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL],
            revenu: !isNil(
              getVictimRevenu(
                el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                victims,
                judiciaryProcessId,
              ),
            )
              ? getVictimRevenu(
                  el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
                  victims,
                  judiciaryProcessId,
                )
              : el.expertiseId === 1
              ? el[VICTIM_EXPERTISE_FIELDS.VICTIM_REVENUE]
              : resolveRevenu(
                  el,
                  civilJudgements,
                  judgementOnMeritsRequest,
                  civilJudgementOnMeritsFormAccountingExpertise,
                ),
            age: getVictimAge(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
              victims,
              claim['lossDate'],
            ),
            mode:
              el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2'
                ? MODE.DECEASED
                : MODE.BLESSE,
            ratePretium: el[VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS],
            lossDate: moment(claim['lossDate']).toISOString(true),
            rateAestheticDamageWithoutConsequence:
              el[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE],
            rateAestheticDamageWithConsequence:
              el[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE],
            rateCareerPrejudice: el[VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE],
            rateSchoolingPrejudice:
              el[VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE],
            rateIPP: el[VICTIM_EXPERTISE_FIELDS.IPP],
            rateITT: el[VICTIM_EXPERTISE_FIELDS.ITT]
              ? el[VICTIM_EXPERTISE_FIELDS.ITT]
              : el.previousItt,
            victimKey: getVictimKey(
              el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID] as string,
              victims,
            ),
            medicalPharmaceuticalFees:
              el[VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES],
            rateMedicalPharmaceuticalFees: '',
            transactionPhase: 1,
            isJusticeFeesChecked:
              resolveValueFromForm(
                get(additionalJudgementOnMeritsInfoForm, 'responsibility', ''),
                get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.responsibility',
                  '',
                ),
              ) === 'Oui'
                ? true
                : false,
            isIDDChecked:
              resolveValueFromForm(
                get(additionalJudgementOnMeritsInfoForm, 'idd', ''),
                get(judgementOnMerits, 'judgementOnMerits.jom.idd', ''),
              ) === 'Oui'
                ? true
                : false,

            iddEffectiveDate: resolveCalculationStartDate(
              get(additionalJudgementOnMeritsInfoForm, 'calculationStartDate'),
              get(
                judgementOnMerits,
                'judgementOnMerits.jom.calculationStartDate',
                '',
              ),
            ),
            JudiciartDecisionDate: !isEmpty(
              get(judgementOnMeritsInfoForm, 'judgementDate', ''),
            )
              ? get(judgementOnMeritsInfoForm, 'judgementDate', '')
              : get(
                  judgementOnMerits,
                  'judgementOnMerits.jom.judgementDate',
                  '',
                ),
            expType: Number(el.expertiseId),
            isRecentExpertiseVictim: el.isRecentExpertiseVictim,
          };

      return (
        checkVictimExistanceCivilPartyById(
          el[VICTIM_EXPERTISE_FIELDS.VICTIM_ID],
          civilProceedingVictims,
        ).includes(true) && objectToReturn
      );
    });
};
